export const SECOND = 1000;

export const MINUTE = SECOND * 60;

export const HOUR = MINUTE * 60;

export const HOURS_IN_DAY = 24;

export const DAYS_IN_WEEK = 7;

export const DAYS_IN_MONTH = 30;

export const DAYS_IN_YEAR = 365;
